// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M1.86.77A2.212 2.212 0 0 0 .038 2.52C.003 2.704 0 3.627.006 12.084l.006 9.36.056.192c.135.466.427.894.804 1.18.195.146.53.307.784.374l.204.054h12.768l.216-.057a2.21 2.21 0 0 0 1.614-1.676c.038-.171.042-.4.042-2.683v-2.496l-.063-.132c-.233-.49-.882-.602-1.234-.212a1.01 1.01 0 0 0-.14.21c-.05.11-.051.12-.063 2.572l-.012 2.461-.072.142a.694.694 0 0 1-.41.345c-.073.018-1.944.026-6.272.026-6.1 0-6.17 0-6.296-.048a.734.734 0 0 1-.376-.36c-.049-.108-.049-.112-.05-9.336V2.772l.057-.12a.845.845 0 0 1 .163-.219c.212-.194-.407-.178 6.56-.171l6.216.006.117.06c.147.075.265.21.327.377.047.126.048.184.048 2.527 0 2.353 0 2.4.049 2.529.065.174.21.333.378.415a.574.574 0 0 0 .317.067c.309-.001.56-.161.693-.443l.063-.132V5.172c0-2.284-.004-2.512-.042-2.683a2.229 2.229 0 0 0-.815-1.29 2.42 2.42 0 0 0-.787-.386l-.204-.057L8.328.753C4.838.75 1.939.759 1.86.77m9.18 6.757-.12.052c-.129.056-4.017 3.942-4.1 4.097-.054.103-.063.15-.064.324 0 .166.01.226.057.324.046.096.449.512 2.016 2.08 2.205 2.209 2.074 2.096 2.427 2.093a.658.658 0 0 0 .524-.219.737.737 0 0 0 .17-.791c-.049-.131-.125-.213-1.338-1.429l-1.287-1.29 7.044-.006 7.043-.006.136-.064c.49-.23.605-.85.227-1.216a1.064 1.064 0 0 0-.207-.152l-.108-.056-7.067-.006-7.067-.006 1.272-1.278c.975-.98 1.285-1.306 1.33-1.398.05-.099.06-.156.06-.324 0-.24-.051-.37-.21-.529-.155-.154-.261-.198-.498-.207-.112-.004-.22 0-.24.007"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const LoginIcon = Icon;
export default LoginIcon;
